/* eslint-disable import/no-default-export */
import React, { lazy, Suspense } from 'react';

import { connect } from 'react-redux';

const ClosedBoardsOverlayPromise = import(/* webpackChunkName: "closed-boards-overlay" */ './closed-boards-overlay');
const ClosedBoardsOverlay = lazy(() => ClosedBoardsOverlayPromise);

const CreateBoardOverlayPromise = import(/* webpackChunkName: "create-board-overlay" */ './create-board-overlay');
const CreateBoardOverlay = lazy(() => CreateBoardOverlayPromise);

const CreateTeamOverlayPromise = import(/* webpackChunkName: "gamma-create-team-overlay" */ './create-team-overlay');
const CreateTeamOverlay = lazy(() => CreateTeamOverlayPromise);

import { OverlayType, State } from 'app/gamma/src/modules';
import { getActiveOverlay } from 'app/gamma/src/selectors/overlays';

interface OverlaysProps {
  overlay: string | null;
}

const Overlays = ({ overlay }: OverlaysProps) => {
  let component;

  switch (overlay) {
    case OverlayType.CreateBoard:
      component = (
        <Suspense fallback={null}>
          <CreateBoardOverlay />
        </Suspense>
      );
      break;
    case OverlayType.ClosedBoards:
      component = (
        <Suspense fallback={null}>
          <ClosedBoardsOverlay />
        </Suspense>
      );
      break;
    case OverlayType.CreateTeam:
      component = (
        <Suspense fallback={null}>
          <CreateTeamOverlay />
        </Suspense>
      );
      break;
    default:
      component = null;
  }

  return component;
};

const mapStateToProps = (state: State) => {
  return {
    overlay: getActiveOverlay(state),
  };
};

export default connect(mapStateToProps)(Overlays);
